import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = {
  path: '/used-cars-for-sale',
  exact: true,
  page: getLoadablePage(() => import(/* webpackChunkName: "used_cars_landing" */ '../pages/index/index')),
  chunkName: 'used_cars_landing',
  enableLooseEtag: true,
};
